import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import dragVerify from '../../common/dragVerify'
import puzzle from "../../common/puzzle.vue";
import md5 from "js-md5";
export default {
  data: function data() {
    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        var reg = /^1[23456789][0-9]\d{8}$|powerchina/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      form: {
        account: "",
        password: ""
      },
      snackbar: false,
      errorMessage: "",
      ispass: true,
      rules: {
        account: [{
          required: true,
          message: '手机号不能为空',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {},
  computed: {
    processed: function processed() {
      if (process.env.NODE_ENV === 'production') {
        if (process.env.type === 'testing') {
          // 测试环境
          return "2073178116";
        } else {
          // 正式环境
          return "2035233657";
        }
      } else {
        // 本地环境
        return "2038788550";
      }
    }
  },
  components: {
    // dragVerify,
    puzzle: puzzle
  },
  methods: {
    // 验证通过
    onMpanelSuccess: function onMpanelSuccess() {
      this.ispass = false;
      //执行代码
    },
    recursionRouter: function recursionRouter(arr) {
      var self = this;
      arr.forEach(function (item) {
        item.children.forEach(function (v) {
          v["path"] = v.router;
          v["name"] = v.router;
          v["component"] = function (resolve) {
            return require(["@/components/".concat(item.router, "/").concat(item.router)], resolve);
          };
          v["meta"] = {
            authe: true
          };
          v.children.forEach(function (subItem) {
            subItem["path"] = v.router;
            subItem["name"] = v.router;
            subItem["component"] = function (resolve) {
              return require(["@/components/".concat(subItem.router, "/").concat(subItem.router, "/").concat(subItem.router)], resolve);
            };
            subItem["meta"] = {
              authe: true
            };
          });
        });
      });
    },
    //过滤一级菜单下子菜单问空的
    filterEmptyArr: function filterEmptyArr(arr) {
      var arr1 = [];
      for (var key in arr) {
        if (arr[key].children.length || arr[key].permissionId == 261) {
          arr1.push(arr[key]);
        }
      }
      return arr1;
    },
    submit: function submit() {
      var self = this;
      self.$refs["form"].validate(function (valid) {
        if (self.ispass) {
          self.$message({
            type: "warning",
            message: "请完成图片验证"
          });
          return false;
        }
        if (valid) {
          Lib.M.ajax({
            'method': "POST",
            'url': 'user/login',
            'params': {},
            'data': {
              tel: self.form.account,
              pwd: md5(self.form.password),
              loginType: 0,
              accessType: 1
            },
            'success': function success(data) {
              sessionStorage.setItem("roles", JSON.stringify(data.obj.auditUserTypes));
              sessionStorage.setItem("data", JSON.stringify(data.obj.user));
              sessionStorage.setItem("token", JSON.stringify(data.obj.token));
              self.$upload.defaults.headers.common["token"] = data.obj.token.tokenId;
              localStorage.setItem("token", JSON.stringify(data.obj.token));
              sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
              sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
              sessionStorage.setItem("menuEng", JSON.stringify(self.filterEmptyArr(data.obj.menuEng)));
              sessionStorage.setItem("permissionEng", JSON.stringify(data.obj.permissionEng));
              self.$store.dispatch("dispatchIsLogin", 1);
              // var permission=data.obj.permission;
              // self.recursionRouter(permission);
              // console.log(permission)
              // self.$router.addRoutes(permission);
              // self.$router.push("/main/basicData");
              //审计人员登录跳转到其他页面

              if (data.obj.user.roles[0].roleId === 'role-20250808112144-91jz607e') {
                window.location.href = "#/main/bidMarketList";
              } else {
                if (data.obj.user.dept.branchUnitId) {
                  if (data.obj.user.dept.branchUnitId === 'dept-20230209092043-mq40sqtk' || data.obj.user.dept.branchUnitId === 'dept-20190923113717-1j4004gd') {
                    window.location.href = "#/main/international/dataScreening";
                  } else {
                    window.location.href = "#/main/dataScreening";
                  }
                } else {
                  window.location.href = "#/main/dataScreening";
                }
              }
            },
            "error": function error(data) {
              self.ispass = false;
              self.showSnackbar();
              if (data.code) {
                self.errorMessage = data.userInfo;
              } else {
                self.errorMessage = "连接超时!请稍后再试";
              }
            }
          });
        } else {
          return;
        }
      });
    }
  },
  mounted: function mounted() {
    // let self=this;
    // window.callback = function(res){
    //   console.log(res)
    //   // res（用户主动关闭验证码）= {ret: 2, ticket: null}
    //   // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    //   if(res.ret === 0){
    //     self.onMpanelSuccess();
    //     alert(res.ticket)   // 票据
    //   }
    // }
  }
};